export default __webpack_public_path__ + "static/media/disabled-challenge-icon.8f6dc4ed.svg";